var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoLiveProfiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 97,
    viewBox: "0 0 179 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.318 19.7912C147.215 19.1116 146.573 18.6585 145.89 18.7615C145.207 18.8645 144.752 19.5029 144.856 20.1825C145.042 21.3358 145.269 24.9399 144.007 26.4021C143.738 26.711 143.407 26.8963 142.993 26.9787L143.117 20.1002C143.138 19.091 142.331 18.2878 141.317 18.2878C140.303 18.2878 139.496 19.1116 139.517 20.1207L139.848 33.1777C139.413 33.1159 139.082 32.9099 138.792 32.601C137.53 31.1388 137.758 27.5348 137.944 26.3815C138.047 25.7019 137.592 25.0634 136.909 24.9605C136.226 24.8575 135.585 25.3106 135.481 25.9902C135.399 26.5668 134.674 31.6125 136.889 34.2074C137.654 35.0929 138.689 35.6078 139.889 35.6696L140.034 41.3537H142.786L142.993 29.4912C144.173 29.4089 145.187 28.894 145.932 28.029C148.146 25.4341 147.422 20.3679 147.318 19.7912Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4548 30.8711C31.3927 30.4387 30.9788 30.1503 30.5442 30.2121C30.1097 30.2739 29.82 30.6858 29.882 31.1183C29.9855 31.8597 30.1304 34.1457 29.344 35.0724C29.1784 35.2784 28.9715 35.4019 28.7025 35.4431L28.7853 31.0565C28.806 30.4181 28.2886 29.9032 27.6471 29.9032C27.0056 29.9032 26.4883 30.4387 26.509 31.0771L26.7159 39.3973C26.4469 39.3561 26.2193 39.2325 26.0537 39.0266C25.2467 38.0998 25.3915 35.7932 25.5157 35.0724C25.5778 34.6399 25.288 34.228 24.8535 34.1663C24.4189 34.1045 24.0257 34.3928 23.943 34.8253C23.8809 35.196 23.4256 38.4087 24.8535 40.0563C25.3501 40.6329 25.9916 40.9418 26.778 41.0036L26.8608 44.6283H28.599L28.7232 37.0701C29.4682 37.0083 30.1304 36.6994 30.6063 36.1433C31.9514 34.4546 31.4961 31.2212 31.4548 30.8711Z",
    fill: "#BDBDBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5 96.9999C138.929 96.9999 179 82.8834 179 65.4698C179 48.0562 138.929 33.9396 89.5 33.9396C40.0705 33.9396 0 48.0562 0 65.4698C0 82.8834 40.0705 96.9999 89.5 96.9999Z",
    fill: "url(#paint0_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3105 32.4363H71.8686C69.8199 32.4363 68.1644 30.7887 68.1644 28.7499C68.1644 28.235 67.7299 27.8025 67.2125 27.8025H64.3775C63.6118 27.8025 63.0117 27.1847 63.0117 26.4433C63.0117 25.6813 63.6325 25.084 64.3775 25.084H67.2125C69.2612 25.084 70.9167 26.7316 70.9167 28.7705C70.9167 29.2853 71.3513 29.7178 71.8686 29.7178H74.3105C75.0761 29.7178 75.6762 30.3356 75.6762 31.077C75.6969 31.8184 75.0761 32.4363 74.3105 32.4363Z",
    fill: "url(#paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4017 0C75.0968 0 68.9094 6.09597 68.7439 13.3452C68.5783 21.1093 68.6818 28.7705 69.9855 36.4316C70.6063 39.4796 71.3927 42.4246 72.3653 45.3696C72.7791 46.5435 74.1242 47.4703 75.3038 47.4703C75.3865 47.4703 75.4279 47.4703 75.5107 47.4703C76.6902 47.4703 77.2076 46.5435 76.7523 45.3902C76.4419 44.6076 76.8351 43.9692 77.6215 43.9898C78.4078 44.0104 79.2769 44.6488 79.608 45.4108C80.1047 46.5435 81.5326 47.4497 82.7121 47.4497C82.7949 47.4497 82.8363 47.4497 82.919 47.4497C84.0986 47.4497 84.5538 46.5641 83.9951 45.452C83.6226 44.69 83.9951 44.0722 84.7608 44.0928C85.5471 44.1134 86.4576 44.7312 86.8508 45.4726C87.4302 46.5847 88.9202 47.4497 90.1204 47.4497C90.2032 47.4497 90.2446 47.4497 90.3273 47.4497C91.5069 47.4497 91.8794 46.5847 91.2586 45.5138C90.8447 44.7724 91.1551 44.1752 91.9414 44.1958C92.7278 44.2163 93.6797 44.8136 94.1143 45.555C94.7765 46.6259 96.3492 47.4703 97.5287 47.4703C97.5701 47.4703 97.5908 47.4703 97.6322 47.4703C98.8738 47.4703 99.1842 46.6053 98.4393 45.4932C96.8252 42.8159 95.6663 40.1798 94.7765 37.173C93.0382 29.3265 93.7625 21.5418 94.6523 13.6335C95.5835 6.24013 89.8928 0 82.4017 0Z",
    fill: "url(#paint2_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3098 16.0431C72.5928 16.9492 74.7036 15.3429 73.6689 11.78C73.6275 11.5947 73.3585 11.5535 73.2757 11.7594C72.3445 13.9836 69.7785 14.9722 71.3098 16.0431Z",
    fill: "#801E0B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1251 10.9769C75.5938 11.6154 78.346 20.2033 82.6296 17.5054C85.237 15.8578 82.8779 14.2309 80.2291 13.2629C78.6357 12.6657 78.0563 10.5856 77.1251 10.9769Z",
    fill: "#801E0B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4001 23.2924C77.5201 23.2924 78.428 21.9738 78.428 20.3474C78.428 18.7209 77.5201 17.4023 76.4001 17.4023C75.28 17.4023 74.3721 18.7209 74.3721 20.3474C74.3721 21.9738 75.28 23.2924 76.4001 23.2924Z",
    fill: "#801E0B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2431 32.4363H81.8012C79.7526 32.4363 78.0971 30.7887 78.0971 28.7499C78.0971 28.235 77.6625 27.8025 77.1452 27.8025H74.3101C73.5445 27.8025 72.9443 27.1847 72.9443 26.4433C72.9443 25.6813 73.5651 25.084 74.3101 25.084H77.1452C79.1938 25.084 80.8493 26.7316 80.8493 28.7705C80.8493 29.2853 81.2839 29.7178 81.8012 29.7178H84.2431C85.0088 29.7178 85.6089 30.3356 85.6089 31.077C85.6296 31.8184 85.0088 32.4363 84.2431 32.4363Z",
    fill: "#801E0B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 89.5029,
    y1: 19.6389,
    x2: 89.5029,
    y2: 69.1563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4764,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 64.2387,
    y1: 24.7403,
    x2: 69.3677,
    y2: 28.8038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#F54141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7095,
    stopColor: "#DD2222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D41717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 68.4104,
    y1: 6.08447,
    x2: 96.5467,
    y2: 45.0323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#F54141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7095,
    stopColor: "#DD2222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B31616"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLiveProfiles);
export default __webpack_public_path__ + "static/media/no-live-profiles.b2aee62dcad9d13560dbb391784e98c8.svg";
export { ForwardRef as ReactComponent };